/**
 * Converts an object with snake_case properties to camelCase.
 */
export function convertObjectToCamelCase<InputType = any, OutputType = any>(obj: InputType): OutputType {
  if (!obj || typeof obj !== 'object') {
    return obj as any;
  }

  const result: any = {};

  Object.keys(obj).forEach((key) => {
    let value = obj[key];
    if (Array.isArray(value)) {
      value = value.map((item) => {
        if (item && typeof item === 'object') {
          item = convertObjectToCamelCase(item);
        }

        return item;
      });
    } else if (value && typeof value === 'object') {
      value = convertObjectToCamelCase(value);
    }

    result[key.replace(/_([a-z])/g, (...match) => match[1].toUpperCase())] = value;
  });

  return result;
}

export function deepCopy<InputType = any, OutputType = any>(inObject: InputType): OutputType | InputType {
  let outObject, value, key;

  if (typeof inObject !== 'object' || inObject === null) {
    return inObject; // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {};

  for (key in inObject) {
    if (inObject.hasOwnProperty(key)) {
      value = inObject[key];

      // Recursively (deep) copy for nested objects, including arrays
      outObject[key] = deepCopy(value);
    }
  }

  return outObject;
}
